import ProjectOneLandingView from '@/projectOne/views/ProjectOneLandingView';
import ProjectOnePaintAndThemeView from '@/projectOne/views/ProjectOnePaintAndThemeView';
import ProjectOneGenericView from '@/projectOne/views/ProjectOneGenericView';
import ProjectOneRightRailView from '@/projectOne/views/ProjectOneRightRailView';
import ProjectOneSummaryView from '@/projectOne/views/ProjectOneSummaryView';
import ProjectOneLeadGenView from '@/projectOne/views/ProjectOneLeadGenView';

const routes = [
  {
    path: '/:buildId',
    name: 'chooseModel',
    component: ProjectOneLandingView,
    meta: {
      nav: true,
      position: 1,
    },
  },
  {
    path: '/:buildId/theme',
    name: 'paintTheme',
    component: ProjectOnePaintAndThemeView,
    meta: {
      nav: true,
      position: 2,
    },
  },
  {
    path: '/:buildId/personalize',
    name: 'personalize',
    component: ProjectOneRightRailView,
    meta: {
      nav: true,
      position: 3,
    },
  },
  {
    path: '/:buildId/frame',
    name: 'frameOptions',
    component: ProjectOneGenericView,
    meta: {
      nav: true,
      position: 4,
    },
  },
  {
    path: '/:buildId/drivetrain',
    name: 'drivetrain',
    component: ProjectOneRightRailView,
    meta: {
      nav: true,
      position: 5,
    },
  },
  {
    path: '/:buildId/components',
    name: 'components',
    component: ProjectOneRightRailView,
    meta: {
      nav: true,
      position: 6,
    },
  },
  {
    path: '/:buildId/accessories',
    name: 'accessories',
    component: ProjectOneRightRailView,
    meta: {
      nav: true,
      position: 7,
    },
  },
  {
    path: '/:buildId/summary',
    name: 'summary',
    component: ProjectOneSummaryView,
    meta: {
      nav: true,
      position: 8,
    },
  },
  {
    path: '/:buildId/send-to-retailer',
    name: 'leadGen',
    component: ProjectOneLeadGenView,
    meta: {
      nav: false,
      position: 9,
    },
  },
];

export default routes;
